import "./Home.scss";
import 'primeicons/primeicons.css';
import { HomePageIndex } from '../../features/homepage';

export const Home = () => {
    return (
        <div>
            <HomePageIndex/>
        </div>
    )
}

export default Home


 